module.exports = __webpack_public_path__ + "static/media/driving-licence-circle.731d4cba.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/driving-licence-circle.svg
 ** module id = 1270
 ** module chunks = 0
 **/